module.exports = __webpack_public_path__ + "img/choose.6ca86a8f.svg";